import { render, staticRenderFns } from "./cardBody.vue?vue&type=template&id=7c835991&scoped=true"
import script from "./cardBody.vue?vue&type=script&lang=js"
export * from "./cardBody.vue?vue&type=script&lang=js"
import style0 from "./cardBody.vue?vue&type=style&index=0&id=7c835991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c835991",
  null
  
)

export default component.exports